import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
import arrowCircled from "./assets/arrowCircled.svg";
import arrowLeft from "./assets/arrowLeft.svg";
import arrowTop from "./assets/arrowTop.svg";
import backward from "./assets/backward.svg";
import chat from "./assets/chat.svg";
import checked from "./assets/checked.svg";
import checkedThin from "./assets/checkedThin.svg";
import cross from "./assets/cross.svg";
import crossThin from "./assets/crossThin.svg";
import documents from "./assets/documents.svg";
import arrowZLand from "./assets/arrow-zLand.svg";
import dropdownArrow from "./assets/dropdownArrow.svg";
import discountMark from "./assets/discountMark.svg";
import exit from "./assets/exit.svg";
import external from "./assets/external.svg";
import home from "./assets/home.svg";
import mapMarker from "./assets/mapMarker.svg";
import link from "./assets/link.svg";
import ok from "./assets/ok.svg";
import personal from "./assets/personal.svg";
import phone from "./assets/phone.svg";
import phoneHandset from "./assets/phoneHandset.svg";
import phoneFilled from "./assets/phoneFilled.svg";
import play from "./assets/play.svg";
import search from "./assets/search.svg";
import settings from "./assets/settings.svg";
import tariffCheck from "./assets/tariffCheck.svg";
import arrowDown from "./assets/arrowDown.svg";
import metro from "./assets/metro.svg";
import infinity from "./assets/infinity.svg";
import info from "./assets/info.svg";
import star from "./assets/star.svg";
import camera from "./assets/camera.svg";
import sort from "./assets/sort.svg";
import handicapped from "./assets/handicapped.svg";
import erase from "./assets/erase.svg";
import minus from "./assets/minus.svg";
import plus from "./assets/plus.svg";
import pen from "./assets/pen.svg";
import alfaBankCard from "./assets/alfaBankCard.svg";
import trolley from "./assets/trolley.svg";
import controlsDoubleArrows from "./assets/controlsDoubleArrows.svg";
import yandexPlusGradient from "./assets/yandexPlus/yandexPlusGradient.svg";
import yandexPlusGrey from "./assets/yandexPlus/yandexPlusGrey.svg";
import yandexPlusWhite from "./assets/yandexPlus/yandexPlusWhite.svg";
import lockedToggle from "./assets/locked.svg";
import infinityConstructor from "./assets/infinityConstructor.svg";
import eSim from "./assets/eSim.svg";
import fire from "./assets/fire.svg";
import infinityWhite from "./assets/infinityWhite.svg";
import userAdd from "./assets/userAdd.svg";
import timer from "./assets/timer.svg";
import chevronLeft from "./assets/chevronLeft.svg";
import chevronRight from "./assets/chevronRight.svg";
import chevronRightGray from "./assets/chevronRightGray.svg";
import FTTBHandset from "./assets/FTTBHandset.svg";
import FTTBInfo from "./assets/FTTBInfo.svg";
import warning from "./assets/warning.svg";
import crossZ from "./assets/crossZ.svg";
import gosLogo from "./assets/gosLogo.svg";
var cx = classNames.bind(styles);
var icons = {
  arrowCircled: arrowCircled,
  arrowZLand: arrowZLand,
  arrowLeft: arrowLeft,
  arrowTop: arrowTop,
  backward: backward,
  discountMark: discountMark,
  chat: chat,
  checked: checked,
  cross: cross,
  crossThin: crossThin,
  documents: documents,
  dropdownArrow: dropdownArrow,
  exit: exit,
  external: external,
  home: home,
  mapMarker: mapMarker,
  link: link,
  ok: ok,
  personal: personal,
  phone: phone,
  phoneHandset: phoneHandset,
  phoneFilled: phoneFilled,
  play: play,
  search: search,
  settings: settings,
  tariffCheck: tariffCheck,
  arrowDown: arrowDown,
  metro: metro,
  infinity: infinity,
  info: info,
  checkedThin: checkedThin,
  star: star,
  camera: camera,
  sort: sort,
  handicapped: handicapped,
  erase: erase,
  minus: minus,
  plus: plus,
  pen: pen,
  alfaBankCard: alfaBankCard,
  trolley: trolley,
  controlsDoubleArrows: controlsDoubleArrows,
  yandexPlusGradient: yandexPlusGradient,
  yandexPlusGrey: yandexPlusGrey,
  yandexPlusWhite: yandexPlusWhite,
  lockedToggle: lockedToggle,
  infinityConstructor: infinityConstructor,
  gosLogo: gosLogo,
  eSim: eSim,
  fire: fire,
  infinityWhite: infinityWhite,
  userAdd: userAdd,
  timer: timer,
  chevronLeft: chevronLeft,
  chevronRight: chevronRight,
  chevronRightGray: chevronRightGray,
  FTTBHandset: FTTBHandset,
  FTTBInfo: FTTBInfo,
  warning: warning,
  crossZ: crossZ
};
export var Icon = function Icon(_ref) {
  var name = _ref.name,
    className = _ref.className,
    src = _ref.src,
    fill = _ref.fill,
    markup = _ref.markup,
    lazy = _ref.lazy;
  var IconComponent = markup && 'span' || icons[name];
  return IconComponent ? /*#__PURE__*/React.createElement(IconComponent, {
    className: cx(className, markup && name),
    fill: fill,
    "data-t-id": "components-Icon"
  }) : /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: className,
    loading: lazy ? 'lazy' : undefined,
    src: src && src.replace('{{name}}', name)
  });
};
Icon.defaultProps = {
  src: '//static.beeline.ru/upload/images/emoji/{{name}}.svg'
};
Icon.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string,
  className: PropTypes.string,
  src: PropTypes.string,
  fill: PropTypes.string,
  markup: PropTypes.bool,
  lazy: PropTypes.bool
} : {};
export default Icon;